import { lazy } from "react"
import {
  HIVE_EVENT_VIEW,
  HIVE_EVENT_LIST_VIEW,
  NEW_HIVE_EVENT_VIEW,
} from "@/features/events/hive-events/routes/route-list.ts"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const AllHiveEventsView = lazy(
  () =>
    import(
      "@/features/events/hive-events/views/all-hive-events-view/all-hive-events-view.tsx"
    ),
)

const HiveEventView = lazy(
  () =>
    import(
      "@/features/events/hive-events/views/hive-event-view/hive-event-view.tsx"
    ),
)

const NewHiveEventView = lazy(
  () =>
    import(
      "@/features/events/hive-events/views/new-hive-event-view/new-hive-event-view.tsx"
    ),
)
export const hiveEventRoutes = [
  {
    path: NEW_HIVE_EVENT_VIEW,
    element: <NewHiveEventView />,
  },
  {
    path: HIVE_EVENT_LIST_VIEW,
    element: <AllHiveEventsView />,
  },
  {
    path: HIVE_EVENT_VIEW,
    element: <HiveEventView />,
  },
]

const DESKTOP_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: hiveEventRoutes,
  },
]

export const MOBILE_NO_MENU_LAYOUT_HIVE_EVENT_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: hiveEventRoutes,
  },
]

export const getHiveEventRoutes = (isDesktop: boolean) => {
  if (isDesktop) {
    return DESKTOP_ROUTES
  }
  return MOBILE_NO_MENU_LAYOUT_HIVE_EVENT_ROUTES
}
